import ConditionModel from "../../models/features/api/Conditions/ConditionModel";
import IResult from "../../models/result/IResult";
import { sendGet } from "./generic";

export const getConditions = () : Promise<IResult<ConditionModel[]>> => {
    return sendGet(`/Condition`);
}